document.addEventListener('alpine:init', () => {
  Alpine.data('archiveComponent', opts => ({
    mobileFiltersBarOpen: false,
    searchActive: false,
    searchRequest: opts.searchRequest,
    defaultTitle: opts.defaultTitle || {},
    paged: Number(opts.paged) || 1,
    postsPerPage: Number(opts.postsPerPage) || 12,
    activeFilters: opts.activeFilters || {},
    authorId: opts.authorId || null,
    postTypes: opts.postTypes || null,
    cardsSettings: opts.cardsSettings || null,
    loading: false,
    showNothingFound: opts.showNothingFound || false,

    init() {
      this.initSlider();

      this.$watch('mobileFiltersBarOpen', isOpen => {
        document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      });
    },

    handleSearch() {
      this.paged = 1;
      this.updateURL();
      this.fetchPosts();

      if (window.innerWidth <= 1024) {
        this.mobileFiltersBarOpen = false;
      }
    },

    selectPage(page) {
      this.paged = page;
      this.updateURL();
      this.fetchPosts();
    },

    selectFilter(taxonomy, term) {
      const arr = new Set(this.activeFilters[taxonomy] || []);
      if (arr.has(term)) {
        arr.delete(term);
      } else {
        arr.add(term);
      }
      this.activeFilters = {
        ...this.activeFilters,
        [taxonomy]: Array.from(arr),
      };
      this.paged = 1;
      this.updateURL();
      this.fetchPosts();
    },

    resetFilter(taxonomy) {
      this.activeFilters = {
        ...this.activeFilters,
        [taxonomy]: [],
      };
      this.paged = 1;
      this.updateURL();
      this.fetchPosts();
    },

    resetAllFilters() {
      const cleared = {};
      Object.keys(this.activeFilters).forEach(t => cleared[t] = []);
      this.activeFilters = cleared;
      this.paged = 1;
      this.updateURL();
      this.fetchPosts();
    },

    isFiltersEmpty() {
      return Object.values(this.activeFilters).every(val => {
        if (Array.isArray(val)) {
          return val.length === 0;
        }

        return !val || Object.keys(val).length === 0;
      });
    },

    updateURL() {
      const params = new URLSearchParams();
      if (this.searchRequest) {
        params.set('search', this.searchRequest);
      }
      for (const [tax, terms] of Object.entries(this.activeFilters)) {
        if (terms.length) {
          params.set(tax, terms.join(','));
        }
      }
      const qs = params.toString() ? `?${params.toString()}` : '';
      let raw = window.location.pathname.replace(/\/page\/\d+\/$/, '');
      raw = raw.replace(/\/$/, '');
      let path;
      if (this.paged > 1) {
        path = `${raw}/page/${this.paged}/`;
      } else {
        path = `${raw}/`;
      }

      history.replaceState(null, '', path + qs);
    },

    async fetchPosts() {
      this.loading = true;
      const payload = {
        action: 'filter_resources',
        current: location.pathname,
        page: this.paged,
        posts_per_page: this.postsPerPage,
        search: this.searchRequest,
        author: this.authorId,
        post_type: this.postTypes,
        active_filters: JSON.stringify(this.activeFilters),
        cards_settings: JSON.stringify(this.cardsSettings),
        default_title: JSON.stringify(this.defaultTitle),
      };

      const resp = await fetch(base.ajax_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload).toString(),
      });
      if (!resp.ok) {
        throw new Error(resp.status);
      }
      const json = await resp.json();
      const data = json.data || json;

      this.$nextTick(() => {
        if (this.$refs.archiveList) {
          this.$refs.archiveList.innerHTML = data.posts;
        }
        if (this.$refs.archiveTitle) {
          this.$refs.archiveTitle.innerHTML = data.title || '';
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.innerHTML = data.pagination;
        }
        if (this.$refs.archiveTerms) {
          this.$refs.archiveTerms.innerHTML = data.terms;
        }

        this.showNothingFound = data.posts.length === 0;

        this.loading = false;

        this.$refs.archiveRoot.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    },

    mobileFiltersToggle() {
      this.mobileFiltersBarOpen = !this.mobileFiltersBarOpen;
    },

    initSlider() {
      document.querySelectorAll('.js-archive-menu-slider').forEach(el => {
        new Splide(el, {
          type: 'slide',
          drag: 'free',
          rewind: false,
          arrows: false,
          destroy: false,
          autoWidth: true,
          gap: 8,
          pagination: false,
          mediaQuery: 'min',
          perMove: 1,
          perPage: 1,
          breakpoints: {
            1024: {
              destroy: true,
            },
          },
        }).mount();
      });
    },
  }));
});
